// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3fweP","balanceDisclaimer":"posDashboard_balanceDisclaimer__DG_yK"};